"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "withCell", {
  enumerable: true,
  get: function () {
    return _withCell.withCell;
  }
});

exports.GraphQLProvider = exports.createGraphQLClient = void 0;

var _react = _interopRequireDefault(require("react"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _client = require("@apollo/client");

var _withCell = require("./withCell");

/**
 * Create a GraphQL Client (Apollo) that points to the `apiProxyPath` that's
 * specified in `redwood.toml`.
 */
const createGraphQLClient = config => {
  return new _client.ApolloClient({
    uri: "".concat(window.__REDWOOD__API_PROXY_PATH, "/graphql"),
    cache: new _client.InMemoryCache(),
    ...config
  });
};
/**
 * A GraphQL provider that instantiates a client automatically.
 */


exports.createGraphQLClient = createGraphQLClient;

const GraphQLProvider = ({
  config = {},
  ...rest
}) => {
  return /*#__PURE__*/_react.default.createElement(_client.ApolloProvider, (0, _extends2.default)({
    client: createGraphQLClient(config)
  }, rest));
};

exports.GraphQLProvider = GraphQLProvider;